/* ============================================================
   MagicBeez — Apparition douce des sections au scroll
   Progressive enhancement : sans JS / reduced-motion, contenu visible.
   ============================================================ */
(function () {
  if (window.__mbRevealInit) return;
  window.__mbRevealInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return; // pas d'animation : le contenu reste visible (aucune classe ajoutée)

  document.documentElement.classList.add('mb-anim-ready');

  function reveal(el) { el.classList.add('is-revealed'); }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var targets = scope.querySelectorAll('.mb-section:not(.mb-hero):not(.mb-home-hero):not(.mb-prom):not(.mb-obj-hero):not(.mb-metier-hero):not(.mb-moh)');
    if (!('IntersectionObserver' in window)) { return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
    Array.prototype.forEach.call(targets, function (t) {
      /* Le contenu déjà visible ne doit jamais attendre l'IntersectionObserver :
         cela protège le LCP et évite un flash vide sur mobile. */
      if (t.getBoundingClientRect().top < window.innerHeight * 1.1) {
        reveal(t);
        return;
      }
      t.classList.add('mb-reveal');
      io.observe(t);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  // Dans l'éditeur : révéler immédiatement la section rechargée
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.mb-section').forEach(reveal);
  });
})();
